import { render, staticRenderFns } from "./RecordCard.vue?vue&type=template&id=a19fa754&scoped=true&"
import script from "./RecordCard.vue?vue&type=script&lang=js&"
export * from "./RecordCard.vue?vue&type=script&lang=js&"
import style0 from "./RecordCard.vue?vue&type=style&index=0&id=a19fa754&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a19fa754",
  null
  
)

export default component.exports